// extracted by mini-css-extract-plugin
module.exports = {"chips":"index_chips__YC9iQ"};